import { Link } from 'react-router-dom';
import { useAuth } from '@lib/useAuth';

function Footer() {
  const { user, user_settings } = useAuth();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-gray-200 bg-white">
      <div className="container mx-auto px-4 py-8">
        <div className="grid gap-8 md:grid-cols-3">
          {/* Brand */}
          <div>
            <Link to="/" className="mb-4 flex items-center gap-2">
              <img
                src="/pictures/logo-v4.png"
                alt="Xhalin logo"
                className="h-12 w-12 rounded-full object-contain"
              />
              <span className="logo-font text-2xl font-bold text-gray-900">
                Xhalin
              </span>
            </Link>
            <p className="text-sm text-gray-600">
              The Personalized Paced Breathing Guide.
              <br /> Control the breath — control the moment.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="mb-4 font-semibold text-gray-900">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/"
                  className="text-gray-600 transition-colors hover:text-primary-600"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/dashboard"
                  className="text-gray-600 transition-colors hover:text-primary-600"
                >
                  Start Breathing
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-600 transition-colors hover:text-primary-600"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/leaders"
                  className="text-gray-600 transition-colors hover:text-primary-600"
                >
                  Leaderboard
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="text-gray-600 transition-colors hover:text-primary-600"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/vision-board"
                  className="text-gray-600 transition-colors hover:text-primary-600"
                >
                  Vision Board
                </Link>
              </li>
              <li>
                <Link
                  to="/buddha-game"
                  className="text-gray-600 transition-colors hover:text-primary-600"
                >
                  Buddha Game
                </Link>
              </li>
              {!user && (
                <>
                  <li>
                    <Link
                      to="/signin"
                      className="text-gray-600 transition-colors hover:text-primary-600"
                    >
                      Sign In
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/signup"
                      className="text-gray-600 transition-colors hover:text-primary-600"
                    >
                      Join <span className="logo-font font-bold">Xhalin</span>
                    </Link>
                  </li>
                </>
              )}

              {user && (
                <li>
                  <Link
                    to={
                      user_settings?.profile_name
                        ? `/profile/${encodeURIComponent(String(user_settings.profile_name))}`
                        : '/profile'
                    }
                    className="text-gray-600 transition-colors hover:text-primary-600"
                  >
                    Your Profile
                  </Link>
                </li>
              )}
              <li>
                <Link
                  to="/badges"
                  className="text-gray-600 transition-colors hover:text-primary-600"
                >
                  All Badges
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="mb-4 font-semibold text-gray-900">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/privacy"
                  className="text-gray-600 transition-colors hover:text-primary-600"
                  aria-label="Read our privacy policy"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-gray-600 transition-colors hover:text-primary-600"
                  aria-label="Read our terms of service"
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 border-t border-gray-200 pt-6 text-center text-sm text-gray-600">
          <p>
            © {currentYear} <span className="logo-font font-bold">Xhalin</span>
            . All rights reserved. Built with ❤️ for breathwork enthusiasts.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
